export function isLessThan1HourAgo(date: string | number | Date) {
  let dateParam = date;
  if (!dateParam) {
    return false;
  }
  /** I feel like a cowboy */
  if (typeof dateParam === 'string' && !dateParam.includes('Z')) {
    dateParam += 'Z';
  }
  const isoString = new Date(dateParam).toISOString();
  const genDate = new Date(isoString);
  const hourInMilliseconds = 60 * 60 * 1000;
  const oneHourAgo = new Date(Date.now() - hourInMilliseconds);
  return genDate > oneHourAgo;
}
